import PropTypes from 'prop-types';
import React from 'react';

import AIMS_FLAVORS from 'lib/aimsFlavors';
import { getWidthAndHeightFromAIMSFlavor } from 'lib/imageUtils';
import TeasePicture from 'components/TeasePicture';
import TypeIcon from 'components/TypeIcon';

function VideoListItemImage(props) {
  const {
    altText,
    url,
  } = props;

  const responsiveFlavors = {
    s: AIMS_FLAVORS.FOCAL_120x120,
  };

  const { width, height } = getWidthAndHeightFromAIMSFlavor(responsiveFlavors.s);

  return (
    <div className="ontheshow-video-list-item-image">
      <TeasePicture
        className="ontheshow-video-list-item-image__tease-image"
        url={url}
        responsiveFlavors={responsiveFlavors}
        alt={altText}
        retina
        height={parseInt(height, 10)}
        width={parseInt(width, 10)}
      />
      <TypeIcon
        type="video"
      />
    </div>
  );
}

VideoListItemImage.propTypes = {
  altText: PropTypes.string,
  url: PropTypes.string.isRequired,
};

VideoListItemImage.defaultProps = {
  altText: '',
};

export default VideoListItemImage;
